module.exports = __webpack_public_path__ + "static/media/eroticax-1dcd41ad.88359186.jpg";